var _style, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEverycredLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#1E4383;}\r\n\t.st1{fill:#A5C3E7;}\r\n\t.st2{fill:#7D9ED2;}\r\n\t.st3{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "26.1,10.6 14.4,17.6 14.4,25 14.4,25 14.4,32.4 26.1,39.4 28.2,40.6 35.8,36.2 35.8,32.3 28.2,36.7  17.8,30.7 17.8,25 17.8,25 17.8,19.3 28.2,13.3 35.8,17.7 35.8,13.8 28.2,9.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.6,0H4.4C2,0,0,2,0,4.4v41.1C0,48,2,50,4.4,50h41.1c2.4,0,4.4-2,4.4-4.4V4.4C50,2,48,0,45.6,0z M38.6,22.5 l-10.4-6l-7.7,4.4V25l0,0v4.1l7.7,4.4l10.4-6v10.8l-10.4,6l-3.4-2l-13.6-7.8V25h0v-9.5l13.6-7.8l3.4-2l10.4,6V22.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_64_",
    className: "st1",
    points: "25,28.6 23.6,27.8 23.6,22.5 28.2,25.2 28.2,30.4 28.2,30.4 28.2,25.2 32.8,22.5  28.2,19.9 28.2,19.9 23.6,22.5 23.6,27.8 23.6,27.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_63_",
    className: "st2",
    points: "28.2,25.2 28.2,30.4 32.8,27.8 32.8,22.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_62_",
    className: "st3",
    points: "23.6,22.5 23.6,27.8 25,28.6 28.2,30.4 28.2,30.4 28.2,25.2  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEverycredLogo);
export default __webpack_public_path__ + "static/media/everycred-logo.8e9762865f1d277c78e5217802c415b4.svg";
export { ForwardRef as ReactComponent };